exports = module.exports = require("../../../../../css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".tabBody_containerBody__ZGxPy{overflow:scroll}", ""]);

// Exports
exports.locals = {
	"containerBody": "tabBody_containerBody__ZGxPy"
};